import axios from "axios";

const CACHE_KEY = "tdc_usd_gbp";
const CACHE_TTL = 60 * 60 * 1000; // 1 hour

let _promise = null;

export function getUsdToGbp() {
  // Check cache
  try {
    const cached = JSON.parse(localStorage.getItem(CACHE_KEY));
    if (cached && Date.now() - cached.ts < CACHE_TTL) return Promise.resolve(cached.rate);
  } catch {}

  // Fetch once (deduplicated)
  if (!_promise) {
    _promise = axios
      .get("https://open.er-api.com/v6/latest/USD")
      .then((res) => {
        const rate = res?.data?.rates?.GBP || null;
        if (rate) localStorage.setItem(CACHE_KEY, JSON.stringify({ rate, ts: Date.now() }));
        _promise = null;
        return rate;
      })
      .catch(() => {
        _promise = null;
        return null;
      });
  }
  return _promise;
}

export function getCachedRate() {
  try {
    const cached = JSON.parse(localStorage.getItem(CACHE_KEY));
    if (cached && Date.now() - cached.ts < CACHE_TTL) return cached.rate;
  } catch {}
  return null;
}

export function convertToGbp(usdAmount, rate) {
  if (!rate) return usdAmount;
  return Number(usdAmount) * rate;
}
